import { Heading, Pane, TextareaField, toaster } from 'evergreen-ui'
import React, { useRef } from 'react'
import { AppInputFieldBtn } from '../../../../../widget/styledComponents/input_field.style'
import Cookies from 'js-cookie';
import {useHistory } from 'react-router-dom';
import { gql, useMutation } from '@apollo/client';


export const REQUEST_SUPPORT = gql`
mutation FacilityManager_requestSupport($message: String!) {
  facilityManager_requestSupport(message: $message) {
    code
    success
    error
    token
  }
}
`;

function SupportTab() {
const history = useHistory()
const accesTokenValue = Cookies.get('userAccessToken');

// const [requestSupport, { loading }] = useMutation(REQUEST_SUPPORT);
const [requestSupport] = useMutation(REQUEST_SUPPORT);

const handleSubmit=(e)=>{
    e.preventDefault()
    requestSupport({
        variables: { 
            message: msgRef.current.value,
        },
        context: {
        headers: {
            Authorization: `Bearer ${accesTokenValue}`,
        },
        },
    })
    .then((response) => {
        toaster.success("Your message has been sent, we will get back to you as soon as possible.")
        history.push(`/`);
    })
    .catch((error) => {
        toaster.danger(error.message)
    });
    }


const msgRef = useRef();


return (
<div>
        
<div className='row'>
    <div className='col s12 l5'>
        <form onSubmit={handleSubmit}>
            <Heading >We are here to help</Heading><br/>
            <span className='mb-16'>Our supportive customer care line is available 24/7 via Whatsapp on  08183781220. 
            You can also send us a direct message below</span>
            <br/><br/>
            <Pane>
            
                <TextareaField 
                id="textarea-2" 
                placeholder="Textarea placeholder..." 
                grammarly={true}
                inputHeight={"300px"}
                ref={msgRef}
                />
            </Pane>
            <AppInputFieldBtn>
                Send
            </AppInputFieldBtn>
        </form>
    </div>
    <div className='col s12 l7'></div>
</div>
    </div>
  )
}

export default SupportTab